import { DEFAULT_PADDING } from '@client/components/Block/constants'
import { getPadding as getBlockPadding } from '@client/components/Block/component'
import {
  ITEM_TYPE_LANDING_PAGE,
  ITEM_TYPE_LANDING_PAGE_SUCCESS,
  ITEM_TYPE_SURVEY,
  ITEM_TYPE_SURVEY_THANK_YOU,
} from '@client/components/Editor/settings'
import { SECTION_TYPES } from '@client/components/Section/constants'

export const defaultSettings = {
  fullWidth: true,
}

export const getPadding = ({
  section,
  columnIndex,
  kind,
}) => {
  const sectionType = section?.sectionType
  const padding = getBlockPadding({ section, columnIndex, kind })
  if (
      kind === ITEM_TYPE_LANDING_PAGE ||
      kind === ITEM_TYPE_LANDING_PAGE_SUCCESS ||
      kind === ITEM_TYPE_SURVEY ||
      kind === ITEM_TYPE_SURVEY_THANK_YOU
  ) {
    if (sectionType === SECTION_TYPES.ONECOL) {
      return `0 ${2 * DEFAULT_PADDING}px`
    }
    if (sectionType === SECTION_TYPES.TWOCOL) {
      if (columnIndex === 0) {
        return `0px ${DEFAULT_PADDING}px 0 ${2 * DEFAULT_PADDING}px`
      }
      if (columnIndex === 1) {
        return `0px ${2 * DEFAULT_PADDING}px 0 ${DEFAULT_PADDING}px`
      }
    }
  }
  return padding
}

export const getDefaultContent = ({
  section,
  columnIndex,
  kind,
}) => {
  const padding = getPadding({
    section,
    columnIndex,
    kind,
  })
  return (
    `<div style="padding: ${padding};font-size: ${14}px">

</div>`
  )
}
